<template>
  <div class="coach">
    <div class="slider">
      <v-carousel
        :cycle="true"
        :progress="true"
        :interval="8000"
        :height="$vuetify.breakpoint.smAndDown ? 250 : 420"
        hide-delimiters
        show-arrows-on-hover
      >
        <v-carousel-item v-for="(slide, i) in slider" :key="i">
          <v-img
            :src="slide.image"
            :height="$vuetify.breakpoint.smAndDown ? 250 : 420"
            max-width="100%"
          />
          <div class="slide-text">
            {{ slide.title }} (seit
            <animated-number
              :value="slide.year"
              :formatValue="theFormat"
              :duration="2000"
              :delay="500"
            />
            )<br />{{ slide.leader }}
          </div>
        </v-carousel-item>
      </v-carousel>
    </div>
    <div class="myWordCloud">
      <wordcloud
        :data="defaultWords"
        nameKey="name"
        valueKey="value"
        :color="myColors"
        :showTooltip="false"
        :rotate="{ from: 0, to: 0, numOfOrientation: 5 }"
        :margin="{ top: 5, right: 5, bottom: 5, left: 5 }"
        :fontSize="[20, 80]"
      />
    </div>
  </div>
</template>
<style scoped>
.coach {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-content: center;
}

.slider {
  align-self: center;
  width: 800px;
  max-width: 100%;
}

.slide-text {
  background-color: rgba(255, 255, 255, 0.5);
  position: absolute;
  padding: 5px;
  border-radius: 5px;
  top: 16px;
  left: 16px;
}

.myWordCloud {
  width: 100%;
  height: 100%;
}

.myWordCloud div {
  height: 100%;
}

@media only screen and (max-width: 1000px) {
  .myWordCloud div {
    height: 1200px;
  }
}

@media only screen and (min-width: 1001px) and (max-width: 1500px) {
  .myWordCloud div {
    height: 800px;
  }
}

@media only screen and (min-width: 1501px) {
  .myWordCloud div {
    height: 700px;
  }
}
</style>

<script>
import wordcloud from "vue-wordcloud";
import AnimatedNumber from "animated-number-vue";
import { shuffle } from "./shuffle";

const names = [
  "Albert Goll",
  "Amelie Fischer",
  "Amelie Rehm",
  "Andrea Autenrieth",
  "Andrea Baumeister",
  "Andreas Füller",
  "Andreas Rauschmaier",
  "Andreas Troll",
  "Anett Hagenmaier",
  "Angela Renner",
  "Anne Rieck",
  "Arno Volles",
  "Ayos Bengel",
  "Barbara Priel",
  "Basti Götz",
  "Beate Tornow",
  "Bine Mintus",
  "Brigitte Rauschmaier",
  "Carina Gutbrod",
  "Caroline Lamparter",
  "Chrisi Wölfle",
  "Christine Katz",
  "Clara Rehm",
  "Daniel Kraft",
  "Daniel Stark",
  "Daniela Mutschler",
  "Dieter Greiner",
  "Doris Bohnacker",
  "Edgar Rauschmaier",
  "Elisabeth Stehle",
  "Elke Koch-Gutbrod",
  "Elmar Sailer",
  "Ewald Rehm",
  "Florian Bohnacker",
  "Florian Weigt",
  "Franzi Rehm",
  "Fritzi Sailer",
  "Gabriel Sailer",
  "Georg Rauschmaier",
  "Gisela Schweizer-Hohl",
  "Gisela Tritschler",
  "Gregor Bek",
  "Hans-Georg Riek",
  "Heike Zeh",
  "Heinz Göser",
  "Heinz Weber",
  "Hildegard Schäftner",
  "Hubert Rauschmaier",
  "Ines Gutbrod",
  "Ivica Maric",
  "Jessica Bauerschafter",
  "Joachim Tornow",
  "Joachim Tritschler",
  "Jochen Schweizer",
  "Johannes Walter",
  "Julia Mayer",
  "Jürgen Rieck",
  "Jürgen Schwöbel ",
  "Jürgen Stucke Ralf Gansloser",
  "Jürgen Uhlmann",
  "Justin Tritschler",
  "Karl Bauerschafter",
  "Kathrin Walter",
  "Katja Bek",
  "Kerstin Baumann",
  "Konstantin Grupp",
  "Lena Walter",
  "Lisa Reiff",
  "Lisa Stehle",
  "Luca Rauschmaier",
  "Manfred Nille",
  "Manuel Füller",
  "Marco Rauschmaier",
  "Marie Blaha",
  "Martin Schneck",
  "Mascha Graeter",
  "Mathis Baumann",
  "Max Hellwirth",
  "Max Rieck",
  "Melanie Striebel",
  "Michael Baur",
  "Michaela Priel",
  "Michaela Rehm",
  "Mika Barth",
  "Mike Giebner",
  "Monika Brosch",
  "Nicole Wahl",
  "Niklas Ramminger",
  "Niko Bültmann",
  "Nina Bohnacker",
  "Norbert Ebinger",
  "Olivia Falkenstein",
  "Patrick Rauschmaier",
  "Petra Tritschler",
  "Regina Stehle",
  "Reinhard Mutschler",
  "Richard Tritschler",
  "Robin Rehm",
  "Romy Baumann",
  "Sabine Burri",
  "Sara Wahl",
  "Sasa Dojcinovic",
  "Simon Baumann",
  "Simon Füller",
  "Simone Füller",
  "Sophia Goller",
  "Steffen Großmann",
  "Steffi Uhlmann",
  "Steven Simon",
  "Svenja Kneer",
  "Svenja Troll",
  "Timo Greiner",
  "Tina Walter",
  "Udo Buck",
  "Verena Mayer",
  "Werner Baumeister",
  "Wolfgang Schillinger",
  "Yannick Wiume"
].map(name => ({
  name,
  value: 20
}));

const slider = shuffle([
  {
    image: "images/coach/erwachsenensport.jpg",
    title: "Erwachsenensport",
    year: 2020 - 1976,
    leader: "Silvia Öttinger, Silke Frank"
  },
  {
    image: "images/coach/jugendturnen.jpg",
    title: "Jugendturnen",
    year: 2020 - 1976,
    leader: "Steffi Uhlmann"
  },
  {
    image: "images/coach/schwimmen.jpg",
    title: "Schwimmen",
    year: 2020 - 1975,
    leader: "Anja Tritschler"
  },
  {
    image: "images/coach/tischtennis.jpg",
    title: "Tischtennis",
    year: 2020 - 1984,
    leader: "Manfred Rehm"
  },
  {
    image: "images/coach/fußball-ah.jpg",
    title: "Fußball AH",
    year: 2020 - 1930,
    leader: "Steffen Authaler"
  },
  {
    image: "images/coach/fußball-aktive.jpg",
    title: "Fußball Aktive",
    year: 2020 - 1930,
    leader: "Jochen Doll"
  },
  {
    image: "images/coach/fußball-jugend.jpg",
    title: "Fußball Jugend",
    year: 2020 - 1952,
    leader: "Freddy Wiume"
  },
  {
    image: "images/coach/ski-rad.jpg",
    title: "Ski/Rad",
    year: 2020 - 1986,
    leader: "Achim Wahl"
  },
  {
    image: "images/coach/volleyball.jpg",
    title: "Volleyball",
    year: 2020 - 1984,
    leader: "Dominik Dolejsi"
  }
]);

export default {
  name: "coach",
  components: {
    AnimatedNumber,
    wordcloud
  },
  data() {
    return {
      slider,
      myColors: ["#000000", "#f82020"],
      defaultWords: names
    };
  },
  methods: {
    theFormat(number) {
      return (2020 - number).toFixed(0);
    },
    completed() {
      this.scaleClass = true;
    }
  }
};
</script>
